import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutScreenCodeList extends Layout {
    layoutheaderScreenCode: LayoutHeader;
    sourceScreenCodes: DataSource;
    tableScreenCode: Table;
}
